import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import HeaderContent from "../components/HeaderContent";
import CreatorGrid from "../components/CreatorGrid";
import useGetRequest from "../Hooks/useGetRequest";
import { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";
export default function Dashboard(props) {
  const { get, loading } = useGetRequest();
  const [users, setUsers] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const response = await get("home");
      setUsers(response);
    };

    fetchData();
  }, []);
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <>
      <CssBaseline enableColorScheme />
      <Container
        maxWidth="lg"
        component="main"
        sx={{ display: "flex", flexDirection: "column", mt: 5, mb: 2 }}
      >
        <HeaderContent />
      </Container>
      <Container maxWidth="xl" sx={{ pb: 6 }}>
        {users?.featured?.length > 0 && (
          <CreatorGrid
            creatorTypes="Featured"
            creatorList={users.featured}
            itemToDisplay={4}
          />
        )}
        {users?.youtube?.length > 0 && (
          <CreatorGrid
            creatorTypes="YouTube"
            creatorList={users.youtube}
            itemToDisplay={4}
          />
        )}
        {users?.instagram?.length > 0 && (
          <CreatorGrid
            creatorTypes="Instagram"
            creatorList={users.instagram}
            itemToDisplay={4}
          />
        )}
        {users?.tiktok?.length > 0 && (
          <CreatorGrid
            creatorTypes="TikTok"
            creatorList={users.tiktok}
            itemToDisplay={4}
          />
        )}
      </Container>
    </>
  );
}
